import Snippet from '../../../components/Snippet/Snippet'

const AlertSnip = (props) => {
    return <div className={`alert ${props.cls} ${props.active ? 'active' : ''}`}>
        <span className="close" onClick={props.toggle}>&times;</span>
        <p>Alert - {props.cls}</p>
        <Snippet code={`<div class="alert ${props.cls}">
    <span class="close" onclick="activateAlert(0);">&times;</span>
    <p>Alert - ${props.cls}</p>
</div>`} language='html' />
    </div>
}

export default AlertSnip